export const appsAppIdSdkAuthenticationAnalytics = "/apps/:app_id/sdk_authentication_analytics";
